import { useCallback } from 'react';
import { createFilterType, getFilterName } from '../utils';
export var useAddFilter = function (onChange) {
    return useCallback(function (value, column) {
        if (onChange) {
            var filterProps = {
                type: createFilterType(column),
                filterExtraProps: column.filterExtraProps || {},
                computedValue: column.getFilterCriteria ? column.getFilterCriteria(value) : null,
            };
            onChange(getFilterName(column), value, filterProps);
        }
    }, [onChange]);
};
